var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"w-auto rounded-30 mr-4 text-white xl:text-xl px-10 py-4 my-2",class:[_vm.styling === 'primary' ? _vm.primaryClass : _vm.secondaryClass],attrs:{"tag":"button","to":_vm.routing}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }